export default __webpack_public_path__ + "static/media/interface-15.a50fe6e1.png";